<!-->┌────┬─────────────────────────────────────────────────────────────────────────────────┐<- ->
<- ->│ PA │                                 My Account                                      │<- ->
<- ->└────┴─────────────────────────────────────────────────────────────────────────────────┘<--->

<style scoped lang="less" src=":/PA/styles/ff_dashboard/my_account.less"></style>

<script>
    import MyAccount from "@/pages/ff_dashboard/my_account"

    export default {
        name: "MyAccount.PA",
        mixins: [MyAccount],
    }
</script>